module.exports = __webpack_public_path__ + "static/media/tlyfe.34843acc.png";